export default "__VITE_ASSET__B95S7vY9__"